import React from "react";
import { Decoration_Type } from "./../../ricos-schema/legacy/wix/rich_content/v1";
const decorator = (boldDecoration, element) => {
  const { fontWeightValue } = boldDecoration;
  return /* @__PURE__ */ React.createElement("strong", { key: `bold-${element == null ? void 0 : element.key}`, style: { fontWeight: fontWeightValue || 700 } }, element);
};
const BoldDecorator = {
  rule: (node) => {
    var _a, _b;
    return !!((_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.some(({ type }) => type === Decoration_Type.BOLD));
  },
  decorate: ({ element, node }) => {
    var _a, _b;
    const boldDecoration = (_b = (_a = node.textData) == null ? void 0 : _a.decorations) == null ? void 0 : _b.find(
      ({ type }) => type === Decoration_Type.BOLD
    );
    return decorator(boldDecoration, element);
  }
};
var viewer_default = BoldDecorator;
export {
  viewer_default as default
};
//# sourceMappingURL=viewer.js.map
